/**
 * A "polyfill-ish" replacement for Object.hasOwn, since it isn't supported in old browsers
 */
const hasOwn = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);
export default hasOwn;